import {
  List,
  Datagrid,
  TextField,
  NumberField,
  SelectField,
  SimpleList,
  ShowButton,
  EditButton,
  ReferenceField,
  ReferenceInput,
  AutocompleteInput,
  ListActions,
} from "react-admin";
import { useMediaQuery } from "@mui/material";
import { MOBILE_BREAKPOINT } from "utils/constants";
import SecuredComponent from "server/security/SecuredComponent";
import permissions from "app/permissions";
import { checkPermission } from "server/security/utils";
import { getPermissions } from "auth/security/securityUtils";
import { StudyDurationUnitChoices } from "utils/choices";
import { specialistRequests } from "api/specialistApi";
import { MobileListRow } from "features/MobileListRow";

const filters = [
  <ReferenceInput
    source="specializationId"
    reference={specialistRequests.getSpecializationsSelect()}
    alwaysOn
  >
    <AutocompleteInput
      optionText="nameBg"
      label="Специалност"
      fullWidth
      filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
      style={{ width: 300 }}
    />
  </ReferenceInput>,
];

const ListAdvancedSpecializations = () => {
  const isSmall = useMediaQuery(MOBILE_BREAKPOINT);

  return (
    <List
      filters={filters}
      exporter={false}
      actions={
        <ListActions hasCreate={checkPermission(getPermissions(), permissions.canCreateAdvancedSpecializations)} />
      }
      queryOptions={{ meta: { mixed_provider: true } }}
    >
      {isSmall ? (
        <SimpleList
          primaryText={record => record.nameBg}
          secondaryText={record => (
            <div>
              {record.nameEn}
              <MobileListRow
                fields={[
                  {
                    label: "Ед. за продължителност",
                    value: (
                      <SelectField
                        source="studyDurationUnit"
                        label="Ед. за продължителност"
                        choices={StudyDurationUnitChoices}
                      />
                    ),
                  },
                ]}
              />
              <MobileListRow
                fields={[
                  {
                    label: "Продължителност",
                    value: (
                      <NumberField
                        source="studyDuration"
                        label="Продължителност"
                      />
                    ),
                  },
                ]}
              />
              <MobileListRow
                fields={[
                  {
                    label: "Специалност",
                    value: (
                      <ReferenceField
                        source="specializationId"
                        reference={specialistRequests.getSpecializationsSelect()}
                        label="Специалност"
                        sortable={false}
                      >
                        <TextField source="nameBg" />
                      </ReferenceField>
                    ),
                  },
                ]}
              />
              <MobileListRow
                fields={[
                  {
                    label: "Валидност (год.)",
                    value: (
                      <TextField
                        source="certValidityYears"
                        label="Валидност (год.)"
                      />
                    ),
                  },
                ]}
              />
            </div>
          )}
          tertiaryText={() => (
            <>
              <SecuredComponent permission={permissions.canUpdateAdvancedSpecializationsInfo}>
                <EditButton label="" />
              </SecuredComponent>
              <ShowButton label="" />
            </>
          )}
        />
      ) : (
        <Datagrid bulkActionButtons={false}>
          <TextField
            source="nameBg"
            label="Наименование (БГ)"
          />
          <TextField
            source="nameEn"
            label="Наименование (EN)"
          />
          <SelectField
            source="studyDurationUnit"
            label="Ед. за продължителност"
            choices={StudyDurationUnitChoices}
          />
          <NumberField
            source="studyDuration"
            label="Продължителност"
          />
          <ReferenceField
            source="specializationId"
            reference={specialistRequests.getSpecializationsSelect()}
            label="Специалност"
            sortable={false}
          >
            <TextField source="nameBg" />
          </ReferenceField>
          <TextField
            source="certValidityYears"
            label="Валидност (год.)"
          />
          <SecuredComponent permission={permissions.canUpdateAdvancedSpecializationsInfo}>
            <EditButton />
          </SecuredComponent>
          <ShowButton />
        </Datagrid>
      )}
    </List>
  );
};

export default ListAdvancedSpecializations;
